import { UPDATE_ROUTE_PARAMS, BEFORE_ROUTE_CHANGE } from '../constants';

const initialState = {
  modelSlug: undefined,
  trimSlug: undefined,
  nCode: undefined,
  modelLineCode: undefined,
  routeName: undefined,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case BEFORE_ROUTE_CHANGE: {
      return {
        ...state,
        routeName: action.routeName
      }
    }
    case UPDATE_ROUTE_PARAMS : {
      return {
        ...state,
        ...action.params
      }
    }
    default:
      return state;
  }
}




/** WEBPACK FOOTER **
 ** ./src/redux/reducers/navigation.js
 **/